import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import CanchaPlato from "../../../images/modulo14/canchaplato.png";
import CanchaEscena from "../../../images/modulo14/canchaescena.png";
import CanchaVoley from "../../../images/modulo14/canchavoley.png";
import Modulo14U2Act3 from "../../../DnD/modulo14U2Act3";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad2Actividad3.mp3";

const Actividad5 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[3];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[1].name}: ${modulo14.content[1].activities[5].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[5].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[3].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[3].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  const items = [
    <img src={CanchaPlato} alt="Cancha" className="img-fluid w-300" />,
    <img src={CanchaEscena} alt="Cancha" className="img-fluid w-300" />,
    <img src={CanchaVoley} alt="Cancha" className="img-fluid w-300" />,
  ];
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
        <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul className="mb-5">
        <li>
          Muchas de las palabras que usamos en el castellano del Perú vienen de
          lenguas originarias de nuestro país, sobre todo del quechua.
        </li>
        <li>
          Este es el caso de la palabra “cancha”. Además, “cancha” tiene más de
          un significado en nuestra habla.
        </li>
        <li>
          Coloca las imágenes en el recuadro que contiene el significado de
          cancha que corresponda.
        </li>
      </ul>
      <Modulo14U2Act3 items={items} />

      <GuiaDocente>
        <ul>
          <li>
            Explique que conocerán cómo llegó el castellano al
            Perú y su contacto con las lenguas nativas. A partir de ello, nos
            aproximaremos a algunas palabras que provienen de las lenguas
            nativas y que se han impuesto en el castellano.
          </li>
          <li>
            Pida que observen las tres imágenes que aparecen
            en la actividad y las describan oralmente. Pida a una niña que lea
            la primera afirmación y a un niño que lea la segunda afirmación:
            Muchas de las palabras que usamos en el castellano del Perú vienen
            de lenguas originarias de nuestro país, sobre todo del quechua. Este
            es el caso de la palabra “cancha”. Además, “cancha” tiene más de un
            significado en nuestra habla.
          </li>
          <li>
            Ahora lea usted la indicación para realizar la actividad: Coloca las
            imágenes en el recuadro que contiene el significado de cancha que
            corresponda.. Dé un tiempo para que trabajen
            individualmente. Retome sus respuestas. Para ello, pregunte a sus
            alumnos a qué definición unieron la primera, segunda y tercera
            imagen.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
